// extracted by mini-css-extract-plugin
export var avatarContainer = "_3n-1";
export var largeAvatarContainer = "_3n-2";
export var smallAvatarContainer = "_3n-0";